import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es6.array.slice.js";
// a basic in memory queue with an asynchronous api
var MemoryQueueAsync = /*#__PURE__*/function () {
  function MemoryQueueAsync() {
    _classCallCheck(this, MemoryQueueAsync);
    this.queue = [];
  }
  _createClass(MemoryQueueAsync, [{
    key: "enqueue",
    value: function () {
      var _enqueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this$queue;
        var _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", (_this$queue = this.queue).push.apply(_this$queue, _args));
              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function enqueue() {
        return _enqueue.apply(this, arguments);
      }
      return enqueue;
    }()
  }, {
    key: "dequeue",
    value: function () {
      var _dequeue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var limit,
          _args2 = arguments;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                limit = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                if (limit) {
                  _context2.next = 3;
                  break;
                }
                return _context2.abrupt("return", this.queue.splice(0, this.queue.length));
              case 3:
                if (!(typeof limit !== 'number')) {
                  _context2.next = 5;
                  break;
                }
                throw new Error('queue.dequeue: first argument must be a number');
              case 5:
                if (!(limit < 0)) {
                  _context2.next = 7;
                  break;
                }
                throw new Error('queue.dequeue: cannot dequeue a negative number of items');
              case 7:
                return _context2.abrupt("return", this.queue.splice(0, limit));
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function dequeue() {
        return _dequeue.apply(this, arguments);
      }
      return dequeue;
    }()
  }, {
    key: "toArray",
    value: function () {
      var _toArray = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.queue.slice());
              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function toArray() {
        return _toArray.apply(this, arguments);
      }
      return toArray;
    }()
  }]);
  return MemoryQueueAsync;
}();
export { MemoryQueueAsync as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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